import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { DegreeResponse } from "../../models/dtos";

export const degreesApi = createApi({
  reducerPath: "degreesApi",
  baseQuery: baseAuthQuery("Degrees"),
  tagTypes: ["Degree"],
  endpoints: (builder) => ({
    getDegrees: builder.query<ApiResponse<DegreeResponse[]>, boolean | void>({
      query: (enrollableOnly) => {
        return {
          url: "",
          method: "GET",
          params: enrollableOnly !== undefined ? { enrollableOnly } : {},
        };
      },
      providesTags: ["Degree"],
    }),
    getDegreeById: builder.query<ApiResponse<DegreeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["Degree"],
    }),
    updateDegree: builder.mutation<ApiResponse<DegreeResponse>, Partial<DegreeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["Degree"],
    }),
    deleteDegree: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["Degree"],
    }),
  }),
});
